import React, { useState } from "react";

function Kontakt() {
  const [dane, setDane] = useState({ imie: "", email: "", wiadomosc: "" });
  const [showModal, setShowModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setDane({ ...dane, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return; // Zablokuj ponowne wysyłanie, jeśli już trwa wysyłanie

    setIsSubmitting(true);
    setShowModal(true);

    const webhookUrl = "https://discord.com/api/webhooks/1363932820153696638/dtL7Bm_-XxsI8ndoRuL5ZJXeU2_vF_zenKpZSPjgMVX9r8XuaPkKPaLYvGHv-eDQms_V";
    const payload = {
      username: "Mikus Web - Kontakt",
      avatar_url: "https://i.imgur.com/AfFp7pu.png", // Example profile picture
      embeds: [
        {
          title: "Nowa wiadomość kontaktowa",
          color: 3447003, // Blue color
          fields: [
            { name: "Imię", value: dane.imie, inline: true },
            { name: "Email", value: dane.email, inline: true },
            { name: "Wiadomość", value: dane.wiadomosc, inline: false },
          ],
          timestamp: new Date().toISOString(),
        },
      ],
    };

    try {
      await fetch(webhookUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      console.log("Wiadomość wysłana do webhooka Discord.");
    } catch (error) {
      console.error("Błąd podczas wysyłania wiadomości do webhooka Discord:", error);
    } finally {
      setIsSubmitting(false); // Odblokuj wysyłanie po zakończeniu
    }
  };

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <section className="kontakt p-4 max-w-md mx-auto">
      <h2 className="text-xl font-bold mb-4">Skontaktuj się ze mną</h2>
      <form onSubmit={handleSubmit} className="space-y-3">
        <input
          type="text"
          name="imie"
          placeholder="Imię"
          value={dane.imie}
          onChange={handleChange}
          className="w-full p-2 border rounded"
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={dane.email}
          onChange={handleChange}
          className="w-full p-2 border rounded"
          required
        />
        <textarea
          name="wiadomosc"
          placeholder="Wiadomość"
          value={dane.wiadomosc}
          onChange={handleChange}
          className="w-full p-2 border rounded"
          required
        />
        <button
          type="submit"
          className={`bg-blue-500 text-white px-4 py-2 rounded ${isSubmitting ? "opacity-50 cursor-not-allowed" : ""}`}
          disabled={isSubmitting}
        >
          {isSubmitting ? "Wysyłanie..." : "Wyślij"}
        </button>
      </form>

      {showModal && (
        <div className="modal fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="modal-content bg-white p-6 rounded shadow-lg text-center">
            <p className="mb-4">Dziękujemy za kontakt, {dane.imie}!</p>
            <button
              onClick={closeModal}
              className="bg-blue-500 text-white px-4 py-2 rounded"
            >
              Zamknij
            </button>
          </div>
        </div>
      )}
    </section>
  );
}

export default Kontakt;
